import { GetServerSideProps, InferGetStaticPropsType } from 'next';
import { NextPageWithLayout } from './_app';
import Head from 'next/head';
import Layout from '@/layouts';
import { AppSettings } from '@/shared/app-common';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import SettingsContent from '@/components/Settings';
import { canonicalUrl } from '@/shared/utils';
import { getTdkApi } from '@/lib/service/tdk';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, req, resolvedUrl } = context;
  const [localeRes, tdkRes] = await Promise.all([
    serverSideTranslations(locale, ['common']),
    getTdkApi(resolvedUrl.split('?')[0], locale),
  ]);

  const tempData = localeRes['_nextI18Next']['initialI18nStore'][locale]['common'] ?? {};

  return {
    props: {
      ...localeRes,
      herf: canonicalUrl(req.headers.host, resolvedUrl, locale),
      title: tdkRes?.data?.title ?? tempData['head_Meta_Title'],
      description: tdkRes?.data?.description ?? tempData['head_Meta_Desc'],
    },
  };
};

const IndexPage: NextPageWithLayout<InferGetStaticPropsType<typeof getServerSideProps>> = () => {
  return <SettingsContent />;
};

IndexPage.getLayout = function getLayout(page: React.ReactElement) {
  return (
    <Layout
      head={
        <Head>
          <title>{AppSettings.title}</title>
          <meta name="title" content={AppSettings.title} />
          <meta name="description" content={AppSettings.desc} />

          <meta property="og:title" content={AppSettings?.title} />
          <meta property="og:description" content={AppSettings?.desc} />
          <meta property="og:image" content={AppSettings.logoUrl} />
          <meta property="og:image:secure_url" content={AppSettings.logoUrl} />
          <meta property="og:type" content="summary" />
          <meta property="og:url" content={page.props?.herf} />

          <meta name="twitter:title" content={AppSettings?.title} />
          <meta name="twitter:description" content={AppSettings?.desc} />
          <meta name="twitter:image" content={AppSettings.logoUrl} />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content={page.props?.herf} />

          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href={AppSettings.icoPath} />
          <link rel="canonical" href={page.props?.herf} />
        </Head>
      }
    >
      {page}
    </Layout>
  );
};

export default IndexPage;
